jQuery(document).ready(function($) {
    $('.highlight-expand-toggle').on('click', function(e) {
        e.preventDefault();

        // var moreText = $this.data('more-text');
        // var lessText = $this.data('less-text');

        $(this).siblings('.expanded-content').slideToggle();
        if ($(this).text() === 'Learn more') {
            $(this).text('Show less');
        } else {
            $(this).text('Learn more');
        }
    });
});